import { Typography } from "@mui/material";
import { FC } from "react";
import { styles } from "./stylesMentionDropdown";
import css from "./MentionDropdown.module.scss";
import { HIGHLIGHTED_TICKERS, getTypeBg } from "@/helpers/tickerHelpers";

interface MentionItem {
  data: {
    name: string;
    code: string;
    type: string;
  };
}

interface MentionDropdownProps {
  items: MentionItem[];
  highlightedIndex: number;
  onSelect: (item: MentionItem) => void;
  position: { top: number; left: number };
}
const MentionDropdown: FC<MentionDropdownProps> = ({
  items,
  highlightedIndex,
  onSelect,
  position,
}) => {
  if (!items) return null;

  const filteredItems = items.filter(
    (item) => item?.data?.name || item?.data?.code || item?.data?.type
  );

  return (
    <ul
      style={{
        ...styles.dropdown,
        top: position.top,
        left: position.left,
      }}
      className="hide-scrollbar"
    >
      {filteredItems.length === 0 ? (
        <li className={css.emptyState}>
          <Typography className={css.emptyTitle}>No results found</Typography>
          <Typography className={css.emptySubtitle}>
            Please try specifying a different stock
          </Typography>
        </li>
      ) : (
        filteredItems.map((item, index) => (
          <li
            key={item?.data?.code}
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => onSelect(item)}
            style={{
              ...styles.item,
              backgroundColor:
                index === highlightedIndex ? "#F0F3F8" : getTypeBg(item.data.type),
            }}
          >
            {item.data.name && (
              <Typography noWrap sx={styles.name}>
                {item?.data?.name?.length > 35
                  ? `${item?.data?.name.slice(0, 35)}…`
                  : item?.data?.name}
              </Typography>
            )}
            {(item?.data?.code || item?.data?.type) && (
              <Typography
                sx={
                  HIGHLIGHTED_TICKERS.has(item.data.code)
                    ? styles.codeTypeHighlighted
                    : styles.codeType
                }
              >
                {item?.data?.code}
                {item?.data?.code && item?.data?.type && " | "}
                {item?.data?.type}
              </Typography>
            )}
          </li>
        ))
      )}
    </ul>
  );
};
export default MentionDropdown;
